// Auto-generated normalizer for table: CAR_BOOKING.Siniestro
export function siniestroNormalize(row) {
  return {
    idSiniestro: row.idSiniestro ?? row.IdSiniestro ?? row['idSiniestro'] ?? 0,
    idVehiculo: row.idVehiculo ?? row.IdVehiculo ?? row['idVehiculo'] ?? 0,
    idReserva: row.idReserva ?? row.IdReserva ?? row['idReserva'] ?? 0,
    tipo: row.tipo ?? row.Tipo ?? row['tipo'] ?? '',
    fecha: row.fecha ?? row.Fecha ?? row['fecha'] ?? null,
    importe: row.importe ?? row.Importe ?? row['importe'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
  };
}